import { render } from "./PostmanWidget.vue?vue&type=template&id=504f8b70&scoped=true"
import script from "./PostmanWidget.vue?vue&type=script&lang=js"
export * from "./PostmanWidget.vue?vue&type=script&lang=js"

import "./PostmanWidget.vue?vue&type=style&index=0&id=504f8b70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504f8b70"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QIcon,QSpinner});
